import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { WrapMain } from 'src/shared/modules/wrap_main';
import { gerenciaTecnicaSlice, selectGtoState } from 'src/stateManagement/redux';
import { StandAloneReportViewer } from 'src/tecnica/modules/reports_viewer/reportsViewer';

export const PhysicalCheck = () => {
   const navigate = useNavigate();
  
    const dispatch = useDispatch();
  
    const mainState = useSelector(selectGtoState);
  
    useEffect(() => {
      const filters = mainState.reportFilters;
      const report = mainState?.reportFilters?.activeReport;
  
      if (!report || !filters) {
        handleGoToDashboard();
      } 
  
    }, [mainState.reportFilters])
  
    const handleGoToDashboard = () => {
      dispatch(gerenciaTecnicaSlice.actions.emptyReportData());
      navigate('/gto/dashboard')
    }
  
    return (
      <WrapMain>
        <StandAloneReportViewer report={mainState.reportFilters?.activeReport} onClose={handleGoToDashboard} filters={mainState.reportFilters} />
      </WrapMain>
    )
}
